import {
  calendarUrlForHost,
  calendarUrlForSeats,
} from '@/components/onboarding-booking-step.component';
import { useGetOnboardingSetupStateQuery } from '@/store/features/onboarding-setup.feature';

/**
 * The calendar an onboarding call link books into. The setup run routes the
 * call from the company's counted sales team, and Clu's first chat shows that
 * host, so every other booking link follows the same routing. A workspace with
 * no routed call (no setup run, or a teammate of the member who started it)
 * keeps the seat-band rule.
 */
export function useBookingCalendar(
  seats: string | undefined,
  email: string | undefined,
  { skip = false }: { skip?: boolean } = {}
): string {
  const { data } = useGetOnboardingSetupStateQuery(undefined, { skip });
  const host = data?.call?.host;
  return host ? calendarUrlForHost(host) : calendarUrlForSeats(seats, email);
}
